<template>
    <div>
        {{ msg }}
    </div>
</template>

<script>
export default {
    name: "ApprovalProcess",
    data() {
        return {
            msg: 'Approval Process Here',
        }
    },
}
</script>

<style scoped>

</style>
